import styled from "styled-components";
import { BiChevronUp } from "react-icons/bi";

export const ContactContainer = styled.div`
  background: #8f8073;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  position: relative;
  z-index: 1;
`;
export const ContactInfo = styled.div`
  width: 100%;
  display: grid;
  min-height: 800px;
  padding: 0 30px;
  font-size: 25px;
  grid-auto-columns: minmax(auto, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;

 
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col1 col2'` : `'col1 col2'`};

  @media screen and (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col2' 'col1'` : `'col2 col2' 'col1 col1' `};
`;

export const ConArea1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  grid-area: col1;
`;

export const ConArea2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  grid-area: col2;
`;

export const LogoImg = styled.img`
  max-width: 95px;
  max-height: 60px;
`;
export const LogoWrapper = styled.div`
  margin: 10px;
  margin-right: 20px;
  margin: 20px;
`;

export const ContactFirmName = styled.div`
  font-weight: bold;
  font-size: 30px;
  margin: 20px;
`;

export const ContactBtnWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 20px;
`;

export const UpArrow = styled(BiChevronUp)`
  font-size: 20px;
`;

export const ConAddressIcon = styled.img`
  max-width: 40px;
  max-height: 40px;
`;

export const ConAddressIconPlace = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  aspect-ratio: 1;
  background: #01bf71;
  border-radius: 50%;
  padding: 10px;
  position: absolute;
  top: -95px;
  left: -50px;
`;

export const ConAddressH1 = styled.div`
  font-size: 20px;
  margin: 20px;
`;

export const ConName = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  width: auto;
`;

export const ConAddress = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const ConEmailIcon = styled.img`
  max-width: 40px;
  max-height: 40px;
`;

export const ConEmailIconPlace = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  aspect-ratio: 1;
  background: #01bf71;
  border-radius: 50%;
  padding: 10px;
  position: absolute;
  top: -15px;
  left: -50px;
`;

export const ConEmailH1 = styled.div`
  font-size: 20px;
  margin: 20px;
`;

export const ConEmail = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const ConPhoneIcon = styled.img`
  max-width: 40px;
  max-height: 40px;
`;

export const ConPhoneIconPlace = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  aspect-ratio: 1;
  background: #01bf71;
  border-radius: 50%;
  padding: 10px;
  position: absolute;
  top: 55px;
  left: -50px;
`;

export const ConPhoneH1 = styled.div`
  font-size: 20px;
  margin: 20px;
`;

export const ConPhone = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;
export const ConIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
`;

export const ConText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;
